import PersonIcon from '@material-ui/icons/Person';

import List from './List';

export default {
    list: List,
    icon: PersonIcon
};
